const countries = [
  { code: 'IN', label: 'India', phone: '+91' },
  { code: 'US', label: 'United States', phone: '+1' },
  { code: 'GB', label: 'United Kingdom', phone: '+44' },
  { code: 'AE', label: 'United Arab Emirates', phone: '+971' },
  { code: 'CA', label: 'Canada', phone: '+1' },
  { code: 'AU', label: 'Australia', phone: '+61' },
  { code: 'SG', label: 'Singapore', phone: '+65' },
  { code: 'DE', label: 'Germany', phone: '+49' },
  { code: 'FR', label: 'France', phone: '+33' },
  { code: 'CN', label: 'China', phone: '+86' },
  { code: 'JP', label: 'Japan', phone: '+81' },
  { code: 'KR', label: 'South Korea', phone: '+82' },
  { code: 'BR', label: 'Brazil', phone: '+55' },
  { code: 'ZA', label: 'South Africa', phone: '+27' },
  { code: 'RU', label: 'Russia', phone: '+7' },
  { code: 'IT', label: 'Italy', phone: '+39' },
  { code: 'ES', label: 'Spain', phone: '+34' },
  { code: 'MX', label: 'Mexico', phone: '+52' },
  { code: 'ID', label: 'Indonesia', phone: '+62' },
  { code: 'MY', label: 'Malaysia', phone: '+60' },
  { code: 'TH', label: 'Thailand', phone: '+66' },
  { code: 'PH', label: 'Philippines', phone: '+63' },
  { code: 'VN', label: 'Vietnam', phone: '+84' },
  { code: 'NG', label: 'Nigeria', phone: '+234' },
  { code: 'KE', label: 'Kenya', phone: '+254' },
  { code: 'EG', label: 'Egypt', phone: '+20' },
  { code: 'TR', label: 'Turkey', phone: '+90' },
  { code: 'AR', label: 'Argentina', phone: '+54' },
  { code: 'PK', label: 'Pakistan', phone: '+92' },
  { code: 'BD', label: 'Bangladesh', phone: '+880' },
  { code: 'LK', label: 'Sri Lanka', phone: '+94' },
  { code: 'NP', label: 'Nepal', phone: '+977' },
  { code: 'QA', label: 'Qatar', phone: '+974' },
  { code: 'OM', label: 'Oman', phone: '+968' },
  { code: 'KW', label: 'Kuwait', phone: '+965' },
  { code: 'SA', label: 'Saudi Arabia', phone: '+966' },
  { code: 'NZ', label: 'New Zealand', phone: '+64' },
  { code: 'CH', label: 'Switzerland', phone: '+41' },
  { code: 'NL', label: 'Netherlands', phone: '+31' },
  { code: 'SE', label: 'Sweden', phone: '+46' },
];
export default countries;